// extracted by mini-css-extract-plugin
module.exports = {"notificationBox":"AdminCreateGroup_notificationBox_2MJw8"};